<template>
  <modal ref="Modal" :title="$t('customization.uploadEdit')">
    <alignment-settings-panel :active-element="activeElement" />
    <menu-item to="edit-upload-image">
      {{ $t('customization.uploadEdit') }}
    </menu-item>
    <menu-item
      to="change-upload-effect"
      :class="{
        'cursor-not-allowed opacity-50 pointer-events-none': element.bgRemoval
      }"
    >
      <div class="flex items-center justify-between">
        <div>
          {{ $t('customization.changeImageEffect') }}
        </div>
      </div>
    </menu-item>
    <base-row
      class="px-2 py-4 flex-col"
      :class="{
        'cursor-not-allowed opacity-50 pointer-events-none':
          0 !== element.effect
      }"
    >
      <div class="flex justify-between items-center">
        <span
          >{{ $t('customization.uploadBgRemoval') }} (+{{
            backgroundRemovalCost | currency
          }})</span
        >
        <toggle-button
          v-model="bgRemoval"
          :sync="true"
          color="#0082d5"
          @input="closeModal"
        />
      </div>
      <div class="text-xs pt-4">
        {{ $t('customization.uploadBgRemovalLinkTextExtra') }}:
        <a :href="backgroundRemovalLandingPageUrl" target="_blank">
          {{ $t('customization.uploadBgRemovalLinkText') }}
        </a>
      </div>
    </base-row>
  </modal>
</template>
<script>
import AlignmentSettingsPanel from '../../components/AlignmentSettingsPanel.vue';
import MenuItem from '../../components/MenuItem.vue';
import Modal from '../../components/Modal.vue';
import { TrackingMixin } from '../../mixins/gtm-tracking';
import {
  BACKGROUND_REMOVAL_COST,
  BACKGROUND_REMOVAL_LANDING_PAGE_URL
} from '../../../utils/configure-environment';
import currency from '../../filters/currency';
import Redirect from '@/mixins/redirect';
import ActiveElement from '@/mixins/activeElement';

export default {
  name: 'UpladEditView',
  components: {
    AlignmentSettingsPanel,
    Modal,
    MenuItem
  },
  filters: {
    currency
  },
  mixins: [TrackingMixin, Redirect, ActiveElement],
  data: () => ({
    backgroundRemovalCost: BACKGROUND_REMOVAL_COST,
    backgroundRemovalLandingPageUrl: BACKGROUND_REMOVAL_LANDING_PAGE_URL
  }),
  computed: {
    bgRemoval: {
      get() {
        return this.element.bgRemoval;
      },
      set(bgRemoval) {
        this.updateElement({
          bgRemoval
        });
        this.trackEvent({
          action: 'Picture_BgRemoval_' + (bgRemoval ? 'Enabled' : 'Disabled')
        });
      }
    }
  }
};
</script>
